import { changeLanguage } from 'i18next';
import qs from 'qs';
import { instanceApi } from './index';
function getFormData<DataType>(data: DataType) {
  return qs.stringify(data);
}

export type UserInfoOptions = {
  agreementId: number;
  clientName: string;
  merchant: string;
  isExtension: boolean;
  isFullLoanPayment?: boolean;
  clientFullNameAndGender?: string;
  isRestructure: boolean;
  extTerm?: number;
  paymentPageLanguage?: string | null;
  pageTitle?: 'partPay' | 'extention' | 'pay';
  buttonTitle?: 'partPay' | 'extention' | 'pay';
};

export type GetUserInfo = {
  amount: number;
  csrf: string;
  description: string;
  merchantHost?: string;
  isExtension?: boolean;
  editCardMask: boolean;
  fee: number;
  fullAmount: number;
  lang: 'ru' | 'uk';
  pan?: string;
  tranId: number;
  uuid: string;
  options: UserInfoOptions;
  apayEnabled: boolean;
  gpayEnabled: boolean;
  shouldDisplayAgreementDetails?: boolean;
  shouldDisplayBackToSiteButton?: boolean;
  merchantLink: string;
  expiry?: string;
  cvv?: string;
  holder?: string;
  token?: string;
  tranType?: string;
  phonePaymentEnabled?: boolean;
};

export const getUserInfo = (uuid: string) =>
  instanceApi
    .get<GetUserInfo>(`/frame/frontend/details/${uuid}`, {
      method: 'GET'
    })
    .then((data) => {
      const language = data.data?.options?.paymentPageLanguage;
      const supportedLanguages = ['ru', 'kz', 'en'];
      const selectedLanguage =
        language && supportedLanguages.includes(language) ? language : 'ru';
      localStorage.setItem('i18nextLng', selectedLanguage);
      changeLanguage(selectedLanguage);
      return data.data;
    });

export type SendPayParams = {
  session: string;
  merchant: string;
  card_number: string;
  expiry: string;
  cvv: string;
  save: string;
  email?: string;
  payer?: string;
  amount?: string;
  token?: string;
  applePayToken?: string;
  googlePayToken?: string;
  googlePayPMDescription?: string;
  googlePayMType?: string;
  googlePayPMICardNetwork?: string;
  googlePayPMICardDetails?: string;
  googlePayTokenType?: string;
  referrer?: string;
  phoneNumber?: string;
};

export type SendRetryPaymentParams = {
  tranId: string;
};

export type DownloadInvoiceParams = {
  uuid: string;
};

type SendPayPost = {
  url: string;
  creq?: string;
  threeDSSessionData?: string;
};

type SendRetryPaymentPost = {
  frameUrl: string;
};

export const sendPay = (data: SendPayParams) => {
  const { card_number, ...rest } = data;
  const formData = getFormData({ ...rest, numbercard: card_number });
  return instanceApi
    .post<SendPayPost>('/pay/v2', formData, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then((data) => data.data);
};

export const sendRetryPayment = (data: SendRetryPaymentParams) =>
  instanceApi
    .post<SendRetryPaymentPost>(
      `/pay/v2/retry/${data.tranId}`,
      {},
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
    .then((data) => data.data);

export const downloadInvoice = (data: DownloadInvoiceParams) =>
  instanceApi
    .get(`/frame/frontend/invoice/${data.uuid}/download`, {
      responseType: 'blob'
    })
    .then((data) => data.data);

export const sendUserEncodeData = (id: string, data: { frame: string }) =>
  instanceApi.post(`/frame/frontend/details/status/${id}`, data);

export type TranStatusResponse = {
  statusCode: string;
  codeDesc: string;
  receiptLink: string;
  merchantLink: string;
  statusDescription: null | string;
  amount: number;
  shouldDisplayBackToSiteButton: boolean;
  shouldDisplayRetryButton: boolean;
  tranId: string;
  tranType: string;
  phone: string;
};

export const getTransactionStatus = (id: string) =>
  instanceApi
    .get<TranStatusResponse>(`/frame/frontend/status/${id}`)
    .then((data) => data.data);
